"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkDecorator = void 0;
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const LinkDecoratorBase = styled_components_1.default.div.attrs(() => ({
    className: "button"
})) `
  a {
    color: ${(props) => props.theme.colors.greyBase};
    border-radius: ${({ theme }) => theme.utils.radius};
    border: 1px solid transparent;
    cursor: pointer;
    display: block;
    font-size: 1rem;
    text-align: center;
    text-decoration: none;
    padding: ${({ theme }) => theme.spacings.xs}
      ${({ theme }) => theme.spacings.m};
    position: relative;
    transition: ${({ theme }) => theme.utils.transition.default};
    width: 100%;

    &:disabled {
      cursor: not-allowed;
    }

    &:before {
      content: " ";
      display: inline-block;
    }
  }
`;
const Primary = (0, styled_components_1.default)(LinkDecoratorBase) `
  a {
    background-color: ${(props) => props.theme.colors.greyBase};
    color: ${(props) => props.theme.colors.whiteBase};

    &:hover,
    &.hover {
      background-color: ${(props) => props.theme.colors.greyLighten40};
    }

    &:disabled {
      background-color: ${(props) => props.theme.colors.silverLighten40};
      color: ${(props) => props.theme.colors.greyLighten70};
    }
  }
`;
const Secondary = (0, styled_components_1.default)(LinkDecoratorBase) `
  a {
    background-color: ${(props) => props.theme.colors.silverLighten70};
    color: ${(props) => props.theme.colors.greyBase};
    border: 1px solid ${(props) => props.theme.colors.silverBase};

    &:hover,
    &.hover {
      color: ${(props) => props.theme.colors.greyLighten40};
      background-color: ${(props) => props.theme.colors.silverBase};
    }

    &:disabled {
      background-color: ${(props) => props.theme.colors.silverLighten40};
      color: ${(props) => props.theme.colors.greyLighten70};
    }
  }
`;
const Tertiary = (0, styled_components_1.default)(LinkDecoratorBase) `
  a {
    background-color: ${(props) => props.theme.colors.whiteBase};
    border: 1px solid ${(props) => props.theme.colors.greyBase};
    color: ${(props) => props.theme.colors.greyBase};

    &:hover,
    &.hover {
      background-color: ${(props) => props.theme.colors.silverBase};
    }

    &:disabled {
      background-color: ${(props) => props.theme.colors.silverLighten40};
      color: ${(props) => props.theme.colors.greyLighten70};
      border-color: ${(props) => props.theme.colors.silverLighten40};
    }
  }
`;
const HightLighted = (0, styled_components_1.default)(LinkDecoratorBase) `
  a {
    background-color: #fdce52;
    color: black;
    font-weight: bold;

    &:disabled {
      background-color: ${(props) => props.theme.colors.silverLighten40};
      color: ${(props) => props.theme.colors.greyLighten70};
      border-color: ${(props) => props.theme.colors.silverLighten40};
    }
  }
`;
const transparentDisabledStyle = (color) => `
   color: ${color};
   cursor: not-allowed;
   pointer-events: none;
   
   &:hover {
       color: ${color};
   }
`;
const Transparent = (0, styled_components_1.default)(LinkDecoratorBase) `
  a {
    font-weight: 500;
    text-decoration: underline;
    background-color: transparent;

    &:hover {
      color: ${({ theme }) => theme.colors.greyLighten40};
    }

    ${({ disabled, theme }) => disabled && transparentDisabledStyle(theme.colors.greyLighten70)}
`;
const Links = {
    primary: Primary,
    secondary: Secondary,
    tertiary: Tertiary,
    transparent: Transparent,
    highlighted: HightLighted
};
exports.LinkDecorator = (0, react_1.forwardRef)(({ variant = "primary", ...props }, ref) => {
    return (0, react_1.createElement)(Links[variant], {
        ...props,
        forwardedRef: ref
    });
});
//# sourceMappingURL=index.js.map